import { FC, useState } from "react"
import { Dialog2 } from "./dialog2"
import { Button } from "./button"
import { CheckCircle, Hand, Info, StopCircle, TriangleAlert } from "lucide-react"
import { Spinner } from "./spinner"

export type AlertDialogProps = {
  intent?: "danger" | "warning" | "info" | "success"
  title: string | React.ReactNode
  message?: string | React.ReactNode
  children?: React.ReactNode
  buttons?: React.ReactNode
  onClose: () => void
  onConfirm?: () => Promise<void> | void
  confirmLabel?: string
  cancelLabel?: string
}

export const AlertDialog: FC<AlertDialogProps> = (props) => {
  const [waiting, setWaiting] = useState(false)

  const handleConfirm = async () => {
    if (!props.onConfirm) {
      return
    }

    if (waiting) {
      return
    }

    setWaiting(true)
    await props.onConfirm()
    props.onClose()
  }

  return <Dialog2
    className="max-w-md mx-4"
    title={props.title}
    footer={<div className="flex flex-row items-end justify-center gap-2">
      {props.buttons}
      <Button
        onClick={props.onClose}
        intent="primary"
        label={props.cancelLabel || "No"}
        disabled={waiting}
      />
      {props.onConfirm && <Button
        onClick={handleConfirm}
        intent="danger"
        label={props.confirmLabel || "Yes"}
        disabled={waiting}
      />}
    </div>}
    onClose={props.onClose}
  >
    <div className="p-4 flex flex-row gap-4 justify-center">
      <div className="flex flex-col items-center justify-center">
        {props.intent === "danger" &&
          <div className="bg-red-500 rounded-full p-2 flex flex-col items-center justify-center" >
            <Hand className="w-10 h-10 text-white" />
          </div>
        }

        {props.intent === "warning" &&
          <div className="bg-yellow-500 rounded-full p-2 flex flex-col items-center justify-center" >
            <TriangleAlert className="w-10 h-10 text-black" />
          </div>
        }

        {props.intent === "info" &&
          <div className="bg-blue-500 rounded-full p-2 flex flex-col items-center justify-center" >
            <Info className="w-10 h-10 text-white" />
          </div>
        }

        {props.intent === "success" &&
          <div className="bg-green-500 rounded-full p-2 flex flex-col items-center justify-center" >
            <CheckCircle className="w-10 h-10 text-black" />
          </div>
        }
      </div>

      <div className="flex flex-col gap-4">
        {props.message && <div className="text-lg">{props.message}</div>}
        {props.children}
        {waiting &&
          <div className="flex flex-row items-center justify-center">
            <Spinner size="64px" />
          </div>
        }
      </div>
    </div>
  </Dialog2>
}